import axiosInstance from "../axios";
import { CATEGORIES } from "../../utils/endPoints";
import { categoriesAction } from "./slice";
import { configAction } from "../config/slice";
import {
  categoriesType,
  categoryApiPanelItem,
  categoryConfigPanel,
} from "../../types/categories";
export const getCategories = function () {
  return async (dispatch: Function) => {
    try {
      const config = {
        url: `${CATEGORIES}`,
        method: "GET",
        timout: 0,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      };
      const response = await axiosInstance(config);
      const isGameActive = JSON.parse(
        response.data.data.meta_data!
      ).is_game_active;
      dispatch(configAction.setActiveGame(isGameActive));

      const data: categoriesType[] = response.data.data.components.map(
        (item: categoryApiPanelItem, index: number) => {
          const config = JSON.parse(item.config!) as categoryConfigPanel;
          const sortValueWithKey = item.attributes?.src_sets.value?.sort(
            (a, b) => +a.key - +b.key
          );
          const category: categoriesType = {
            id: String(index),
            type: config.type,
            category: config.category,
            wheel: !!sortValueWithKey?.length ? sortValueWithKey[0].icon : "",
            icon: !!sortValueWithKey?.length ? sortValueWithKey[1].icon : "",
            name: item.component_title,
          };
          return category;
        }
      );
      dispatch(categoriesAction.setCategories(data));
    } catch (error) {}
  };
};
